var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',{ref:"wrapper",attrs:{"type-list":"following","item-source":_vm.fetchFollowings,"dummy-props":{
    headerText: _vm.$t(
      '_web_account-list_dummy_following',
      'You are not following anyone at the moment'
    ),
    text: _vm.$t(
      '_web_account-list_dummy_following_subheader_teams',
      'Start following other players, teams and organisers to keep up to date'
    ),
  }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var user = ref.user;
return (!user.isHidden)?_c('ListItemAccount',_vm._b({key:user.login,staticClass:"mb-3 py-2 pl-5 pr-5"},'ListItemAccount',{
      type: user.type,
      avatar: user.avatar,
      name: _vm.$filters.displayName(user),
      accountId: user.login,
      approved: user.approved,
      vanityId: user.vanityId || user.vanity_id,
    },false),[(_vm.account._canEdit && _vm.myAccountId !== user.login)?_c('div',{staticClass:"d-flex align-items-center",attrs:{"slot":"action"},slot:"action"},[(_vm.myAccountId !== user.login)?_c('FollowBtn',{staticClass:"h-mr-3",attrs:{"model":_vm.createAccountModel(user),"follow-class":""},on:{"toggleFollow":function (isFollow) { return _vm.toggleFollow(isFollow, user); }}}):_vm._e(),_c('AppIcon',{staticClass:"cursor-pointer px-3 py-4 following-smalls ",class:{ disabled: !_vm.canAddToFriend(user) },attrs:{"name":"dots","fill":_vm.$scss.heraMuted,"hover-fill":_vm.$scss.hoverColor},on:{"click":function($event){$event.stopPropagation();return (function (event) { return _vm.dotsClickHandler(event, user); })($event)}}})],1):_vm._e()]):_vm._e()}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }